import React from "react";

const IconGroupSearch = () => (
  <svg
    width="42"
    height="47"
    viewBox="0 0 42 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_193_3404)">
      <path
        d="M29 15.3622H24.1148C23.8475 15.3622 23.5912 15.2521 23.4022 15.056C23.2132 14.8599 23.1071 14.594 23.1071 14.3167V9H14.0077C13.7404 9 13.4841 9.11016 13.2951 9.30624C13.1062 9.50232 13 9.76826 13 10.0456L13.03 28.9544C13.03 29.2317 13.1361 29.4977 13.3251 29.6938C13.5141 29.8898 13.7704 30 14.0377 30H27.9923C28.2596 30 28.5159 29.8898 28.7048 29.6938C28.8938 29.4977 29 29.2317 29 28.9544V15.3622ZM23.1071 9L29 15.3622Z"
        fill="#003F85"
      />
      <path
        d="M24.1148 15.3622H29L23.1071 9V14.3167C23.1071 14.594 23.2132 14.8599 23.4022 15.056C23.5912 15.2521 23.8475 15.3622 24.1148 15.3622Z"
        fill="#003F85"
      />
      <path
        d="M29 15.3622H24.1148C23.8475 15.3622 23.5912 15.2521 23.4022 15.056C23.2132 14.8599 23.1071 14.594 23.1071 14.3167V9M29 15.3622V28.9544C29 29.2317 28.8938 29.4977 28.7048 29.6938C28.5159 29.8898 28.2596 30 27.9923 30H14.0377C13.7704 30 13.5141 29.8898 13.3251 29.6938C13.1361 29.4977 13.03 29.2317 13.03 28.9544L13 10.0456C13 9.76826 13.1062 9.50232 13.2951 9.30624C13.4841 9.11016 13.7404 9 14.0077 9H23.1071M29 15.3622L23.1071 9"
        stroke="#003F85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_193_3404"
        x="0.499996"
        y="0.5"
        width="41"
        height="46"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="6" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_193_3404"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_193_3404"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default IconGroupSearch;
